import React, {Component} from 'react';
import {Button} from "antd";

/**
 * creat by xcc
 * @description 按钮
 * @class Button_rmt
 * @extends {Component}
 */
export default class NormalButton extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {name, onClick, style = {}, btnType} = this.props;
        return (
            <Button type={btnType ? btnType : 'default'} style={{...style}} onClick={() => onClick()}>{name}</Button>
        )
    }

}